module.exports = __webpack_public_path__ + "img/logo-white.ad81f230.png";